<template>
  <el-dialog title="选择短剧" :visible.sync="innerVisible" class="dialog-table" width="800px"
    :before-close="closeDialogTable">
    <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
      <el-form-item label="短剧名" prop="svName">
          <el-input v-model="formInline.svName" placeholder="请输入短剧名" clearable @keyup.enter.native="search" @clear="search" style="width: 220px;"></el-input>
      </el-form-item>
      <el-form-item label="短剧ID" prop="svId">
          <el-input type="number" v-model="formInline.svId" placeholder="请输入短剧ID" clearable @keyup.enter.native="search" @clear="search" style="width: 220px;"></el-input>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </el-form-item>
      <el-form-item>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="tableTh">
      <el-table :data="tableData.result" border ref="multipleTable" @selection-change="handleSelectionChange"
        @row-click="handleRowClick" height="345" row-key="id" style="width: 100%" class="tableStyle">
        <el-table-column type="selection" width="60" align="center">
        </el-table-column>
        <el-table-column label="封面" width="100">
          <template slot-scope="scope">
            <img class="cover-td" :src="scope.row.videolistVo.coverPath" height="50" />
          </template>
        </el-table-column>
        <el-table-column label="短剧名">
          <template slot-scope="scope">
            <p>短剧名：{{ scope.row.videolistVo.svName }}</p>
            <p>展示剧名：{{ scope.row.videolistVo.svName }}</p>
          </template>
        </el-table-column>
        <el-table-column label="短剧备案ID" width="220">
          <template slot-scope="scope">
            <div class="td-info">
              <p>剧目ID: {{ scope.row.albumId }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="statusOnline" label="状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.rackStatus == 0" class="danger-text">已下架</span>
            <span v-if="scope.row.rackStatus == 1" class="succes-text">上架中</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="foot-table" style="text-align:center;">
        <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
          :page-sizes="[5, 20, 50, 100, 200, 500]" :page-size="pageSize" background :current-page="currentPage"
          layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
        </el-pagination>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialogTable">取 消</el-button>
      <el-button type="primary" @click="tableSureBtn">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { listVideo } from "@/api/dysvzk/video/manage";
var videoList = []
export default {
  name: 'BingeVideoTable',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    videoListType: String,
    appId: String
  },
  data() {
    return {
      innerVisible: this.visible,
      selected: [],
      formInline: {
        svId: '',
        svName: ''
      },
      tableData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: []
      },
      currentPage: 1,
      pageSize: 5,
      currentRow: ''
    }
  },
  watch: {
    visible(newValue) {
      this.innerVisible = newValue;
      console.log(this.selectVideo)
      // 弹框显示赋值默认值
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection();
      })
    },
    appId(newValue) {
      this.appId = newValue
      this.getTableVideoMore()
    },
    innerVisible(newValue) {
      this.$emit('update:visible', newValue);
    }
  },
  mounted() {
    this.getTableVideoMore()
  },
  methods: {
    search() {
      this.currentPage = 1
      this.getTableVideoMore()
    },
    resetQuery() {
      this.$refs['formInline'].resetFields()
      this.getTableVideoMore()
    },
    handleRowClick(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    // 多选
    handleSelectionChange(val) {
      videoList = []
      val.forEach((item) => {
        videoList.push(item.svId)
      })
      this.currentRow = val
    },
    // 分页
    handleCurrentChange(value) {
      this.currentPage = value
      this.getTableVideoMore()
    },
    // pageSize切换
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableVideoMore()
    },
    // 确定按钮
    tableSureBtn() {
      if (videoList.length > 0) {
        this.$emit('videoSure', {
          currentRow: this.currentRow,
          videoList: videoList,
        });
        this.$emit('cancelDialogVideo', false);
      } else {
        this.$message.error('请选择短剧')
      }
    },
    // 关闭弹框
    closeDialogTable() {
      this.$emit('cancelDialogVideo', false);
    },
    getTableVideoMore() {
      let json2 = {
        appId: this.appId,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      let json1 = this.formInline;
      let paramJson = { ...json1, ...json2 };
      listVideo(paramJson).then(response => {
        if (response.data.head.flag === 0) {
          this.tableData = response.data.content
        } else {
          this.$message.error(response.data.head.desc)
        }
      });
    },
  }
}
</script>
